(() => {
  'use strict';

  const COLOR_ALIASES = [
    // Longer / more specific names first.
    [['siyah beyaz', 'black white', 'black and white', 'black/white'], ['#050505', '#ffffff']],
    [['siyah kirmizi', 'black red', 'black and red', 'black/red'], ['#050505', '#c72435']],
    [['siyah pembe', 'black pink', 'black and pink', 'black/pink'], ['#050505', '#e88cab']],
    [['beyaz pembe', 'white pink', 'white and pink', 'white/pink'], ['#ffffff', '#e88cab']],
    [['mavi beyaz', 'blue white', 'blue and white', 'blue/white'], ['#3478d4', '#ffffff']],
    [['kirmizi beyaz', 'red white', 'red and white', 'red/white'], ['#c72435', '#ffffff']],

    [['koyu kirmizi', 'dark red', 'wine red', 'sarap kirmizisi'], '#721c2b'],
    [['koyu pembe', 'dark pink'], '#b94874'],
    [['acik pembe', 'light pink', 'toz pembe', 'dusty pink', 'pudra pembe', 'powder pink', 'baby pink'], '#e3a7b7'],
    [['koyu mor', 'dark purple'], '#4e286d'],
    [['acik mor', 'light purple', 'lavanta', 'lavender', 'lila', 'lilac'], '#b59ad8'],
    [['koyu mavi', 'dark blue', 'lacivert', 'navy', 'navy blue'], '#17264f'],
    [['acik mavi', 'light blue', 'bebe mavisi', 'baby blue', 'sky blue', 'gok mavisi'], '#8ec9ee'],
    [['petrol mavisi', 'petrol blue', 'teal'], '#1c7779'],
    [['koyu yesil', 'dark green', 'orman yesili', 'forest green'], '#214c35'],
    [['acik yesil', 'light green'], '#8bcf8e'],
    [['zeytin yesili', 'olive green', 'olive'], '#777a3f'],
    [['mint yesili', 'mint green', 'mint'], '#9ad9c4'],
    [['koyu gri', 'dark grey', 'dark gray', 'antrasit', 'charcoal'], '#3a3b40'],
    [['acik gri', 'light grey', 'light gray'], '#c8c8ca'],
    [['koyu kahverengi', 'dark brown', 'cikolata', 'chocolate brown'], '#4f2e24'],
    [['acik kahverengi', 'light brown', 'taba', 'tan', 'camel'], '#ad744c'],
    [['kirik beyaz', 'off white', 'ekru', 'ecru', 'fildisi', 'ivory'], '#eee7d8'],
    [['rose gold', 'roz gold', 'pembe altin'], 'linear-gradient(135deg,#8f5d55 0%,#e7b5a7 48%,#a66e64 100%)'],
    [['gold', 'altin', 'altin rengi'], 'linear-gradient(135deg,#8f6a12 0%,#f2d16b 50%,#a77c19 100%)'],
    [['silver', 'gumus', 'gumus rengi'], 'linear-gradient(135deg,#74777c 0%,#eceff2 50%,#8b8e93 100%)'],
    [['seffaf', 'transparent', 'clear'], 'transparent-checker'],
    [['gokkusagi', 'rainbow', 'cok renkli', 'multicolor', 'multi color', 'rengarenk', 'karisik renk'], 'rainbow'],

    [['siyah', 'black'], '#050505'],
    [['beyaz', 'white'], '#ffffff'],
    [['kirmizi', 'red'], '#c72435'],
    [['bordo', 'burgundy', 'maroon', 'wine'], '#711f33'],
    [['pembe', 'pink'], '#e88cab'],
    [['fusya', 'fuchsia', 'hot pink'], '#d91578'],
    [['mor', 'purple'], '#7841a1'],
    [['mavi', 'blue'], '#3478d4'],
    [['turkuaz', 'turquoise', 'cyan'], '#2ab6b0'],
    [['yesil', 'green'], '#408c50'],
    [['haki', 'khaki'], '#727348'],
    [['sari', 'yellow'], '#f2d247'],
    [['turuncu', 'orange'], '#e67d22'],
    [['kahverengi', 'brown'], '#795038'],
    [['bej', 'beige'], '#d7c2a3'],
    [['krem', 'cream'], '#f0e5cc'],
    [['gri', 'grey', 'gray'], '#85878c']
  ];

  const normalize = (value) => String(value || '')
    .toLocaleLowerCase('tr-TR')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/ı/g, 'i')
    .replace(/ş/g, 's')
    .replace(/ğ/g, 'g')
    .replace(/ü/g, 'u')
    .replace(/ö/g, 'o')
    .replace(/ç/g, 'c')
    .replace(/[()\[\]{}]/g, ' ')
    .replace(/[_]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  const checker = 'linear-gradient(45deg,#d8d8d8 25%,transparent 25%),linear-gradient(-45deg,#d8d8d8 25%,transparent 25%),linear-gradient(45deg,transparent 75%,#d8d8d8 75%),linear-gradient(-45deg,transparent 75%,#d8d8d8 75%),#ffffff';
  const rainbow = 'conic-gradient(#ef4444,#f59e0b,#f3e34f,#45a85a,#3182ce,#7446aa,#e14e9a,#ef4444)';

  function findColor(value) {
    const input = normalize(value);
    if (!input) return null;

    // Generic arbitrary combinations such as “Siyah + Mor” or “Black/Blue”.
    const combinationColors = [];
    const combinationMap = [
      ['siyah|black', '#050505'],
      ['beyaz|white', '#ffffff'],
      ['kirmizi|red', '#c72435'],
      ['bordo|burgundy|maroon|wine', '#711f33'],
      ['pembe|pink|fusya|fuchsia', '#e88cab'],
      ['mor|purple|lila|lilac|lavender', '#7841a1'],
      ['mavi|blue|lacivert|navy|turkuaz|turquoise|cyan', '#3478d4'],
      ['yesil|green|haki|khaki|mint', '#408c50'],
      ['sari|yellow|gold|altin', '#f2d247'],
      ['turuncu|orange', '#e67d22'],
      ['kahverengi|brown|taba|tan', '#795038'],
      ['bej|beige|krem|cream|ekru|ecru|ivory', '#d7c2a3'],
      ['gri|grey|gray|antrasit|charcoal|silver|gumus', '#85878c']
    ];

    combinationMap.forEach(([pattern, color]) => {
      if (new RegExp(`(^|[^a-z])(${pattern})([^a-z]|$)`, 'i').test(input) && !combinationColors.includes(color)) {
        combinationColors.push(color);
      }
    });

    if (combinationColors.length >= 2) {
      const visibleColors = combinationColors.slice(0, 4);
      const stops = visibleColors
        .map((color, index, arr) => {
          const start = Math.round((index / arr.length) * 100);
          const end = Math.round(((index + 1) / arr.length) * 100);
          return `${color} ${start}% ${end}%`;
        })
        .join(',');
      return {
        background: visibleColors.length === 2
          ? `linear-gradient(90deg,${visibleColors[0]} 0 50%,${visibleColors[1]} 50% 100%)`
          : `conic-gradient(${stops})`,
        light: visibleColors.includes('#ffffff')
      };
    }

    // Exact/specific aliases are evaluated in declared order.
    for (const [aliases, color] of COLOR_ALIASES) {
      const matched = aliases.some((alias) => {
        const key = normalize(alias);
        return input === key || input.includes(key);
      });
      if (!matched) continue;

      if (Array.isArray(color)) {
        return {
          background: `linear-gradient(90deg,${color[0]} 0 50%,${color[1]} 50% 100%)`,
          light: color.includes('#ffffff')
        };
      }
      if (color === 'transparent-checker') {
        return { background: checker, light: true, checker: true };
      }
      if (color === 'rainbow') {
        return { background: rainbow, light: false };
      }
      return {
        background: color,
        light: ['#ffffff', '#eee7d8', '#f0e5cc', '#d7c2a3', '#c8c8ca', '#8ec9ee', '#e3a7b7', '#b59ad8', '#9ad9c4', '#f2d247'].includes(color)
      };
    }


    return null;
  }

  function applyDot(dot) {
    const result = findColor(dot.dataset.shadoraColorValue);
    dot.classList.toggle('is-ready', Boolean(result));
    dot.classList.toggle('is-light', Boolean(result && result.light));
    if (result) {
      dot.style.setProperty('--shadora-auto-color', result.background);
      if (result.checker) {
        dot.style.backgroundSize = '8px 8px';
        dot.style.backgroundPosition = '0 0,0 4px,4px -4px,-4px 0';
      } else {
        dot.style.removeProperty('background-size');
        dot.style.removeProperty('background-position');
      }
    } else {
      dot.style.removeProperty('--shadora-auto-color');
    }
  }

  function applyFill(fill) {
    const result = findColor(fill.dataset.shadoraColorValue);
    const existing = String(fill.dataset.shadoraExistingColor || '').trim();
    const wrapper = fill.closest('[data-shadora-color-wrapper]');
    const canUseExisting = existing && existing !== 'transparent';
    const resolved = result || (canUseExisting ? { background: existing, light: false } : null);

    if (resolved) {
      fill.style.setProperty('--bg-color', resolved.background);
      fill.classList.toggle('is-light', Boolean(resolved.light));
      if (resolved.checker) {
        fill.style.backgroundSize = '8px 8px';
        fill.style.backgroundPosition = '0 0,0 4px,4px -4px,-4px 0';
      } else {
        fill.style.removeProperty('background-size');
        fill.style.removeProperty('background-position');
      }
      wrapper?.classList.add('shadora-color-resolved');
      wrapper?.classList.remove('shadora-color-unresolved');
    } else {
      wrapper?.classList.add('shadora-color-unresolved');
      wrapper?.classList.remove('shadora-color-resolved');
    }
  }

  function buildVariantUrl(baseUrl, variantId) {
    try {
      const url = new URL(baseUrl, window.location.origin);
      url.searchParams.set('variant', variantId);
      return `${url.pathname}${url.search}${url.hash}`;
    } catch (error) {
      const separator = String(baseUrl).includes('?') ? '&' : '?';
      return `${baseUrl}${separator}variant=${variantId}`;
    }
  }

  function updateCardImage(picker, variant) {
    const imageData = variant?.featured_media?.preview_image || variant?.featured_image;
    if (!imageData?.src) return;

    const image = document.getElementById(`${picker.dataset.section}-image`);
    if (!image) return;

    const baseSrc = String(imageData.src).split('?')[0];
    const width = Number(imageData.width || 1066);
    const widths = [165, 360, 533, 720, 940, 1066].filter((item) => width >= item);

    if (widths.length) {
      image.srcset = `${widths.map((item) => `${baseSrc}?width=${item} ${item}w`).join(', ')}, ${baseSrc} ${width}w`;
    }

    image.src = `${baseSrc}?width=533`;
    image.alt = imageData.alt || '';
  }

  function getPickerVariants(picker) {
    if (picker.__shadoraVariants) return picker.__shadoraVariants;

    try {
      picker.__shadoraVariants = JSON.parse(
        picker.querySelector('script[type="application/json"]')?.textContent || '[]'
      );
    } catch (error) {
      picker.__shadoraVariants = [];
    }

    return picker.__shadoraVariants;
  }

  function getSelectedOptions(picker) {
    return Array.from(picker.querySelectorAll('.product-form__input'))
      .map((group) => group.querySelector('input[type="radio"]:checked, select option:checked')?.value)
      .filter((value) => value !== undefined);
  }

  function findCardVariant(picker) {
    const variants = getPickerVariants(picker);
    const selectedOptions = getSelectedOptions(picker);
    const colorIndex = Number(picker.dataset.shadoraColorOptionIndex || 0);
    const selectedColor = picker.querySelector('.product-form__input--swatches input[type="radio"]:checked')?.value;

    let variant = variants.find((item) =>
      item.options?.every((option, index) => option === selectedOptions[index])
    );

    if (!variant || !variant.available) {
      variant = variants.find((item) => item.available && item.options?.[colorIndex] === selectedColor)
        || variants.find((item) => item.options?.[colorIndex] === selectedColor)
        || variant;
    }

    return variant;
  }

  function syncCardPicker(picker) {
    const selectedInput = picker.querySelector('.product-form__input--swatches input[type="radio"]:checked');
    if (!selectedInput) return;

    picker.querySelectorAll('[data-shadora-color-wrapper]').forEach((wrapper) => {
      const input = wrapper.querySelector('input[type="radio"]');
      wrapper.classList.toggle('is-selected', input === selectedInput);
    });

    const selectedColorText = picker.querySelector('[data-shadora-selected-color]');
    if (selectedColorText) {
      selectedColorText.textContent = selectedInput.value || '';
      selectedColorText.title = selectedInput.value || '';
    }

    const variant = findCardVariant(picker);
    if (!variant?.id) return;

    updateCardImage(picker, variant);

    const card = picker.closest('.card-wrapper');
    const variantUrl = buildVariantUrl(picker.dataset.url || '', variant.id);

    card?.querySelectorAll('.full-unstyled-link').forEach((link) => {
      link.href = variantUrl;
    });

    card?.querySelectorAll('[data-product-url]').forEach((element) => {
      element.dataset.productUrl = variantUrl;
    });

    const variantInput = document.getElementById(`${picker.dataset.section}-variant-id`)
      || card?.querySelector('form[action*="/cart/add"] input[name="id"]');

    if (variantInput) {
      variantInput.value = variant.id;
      variantInput.disabled = false;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function initCardPicker(picker) {
    if (picker.dataset.shadoraPickerReady === 'true') return;
    picker.dataset.shadoraPickerReady = 'true';

    picker.addEventListener('change', (event) => {
      if (!event.target.matches('.product-form__input--swatches input[type="radio"]')) return;
      window.requestAnimationFrame(() => syncCardPicker(picker));
    });

    syncCardPicker(picker);
  }

  function applyAll(root = document) {
    root.querySelectorAll?.('[data-shadora-color-dot]').forEach(applyDot);
    root.querySelectorAll?.('[data-shadora-color-fill]').forEach(applyFill);
    root.querySelectorAll?.('[data-shadora-card-swatch-picker]').forEach(initCardPicker);
  }

  let scheduled = false;
  const scheduleApply = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      applyAll(document);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => applyAll(document), { once: true });
  } else {
    applyAll(document);
  }

  const observer = new MutationObserver(scheduleApply);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', scheduleApply);
  document.addEventListener('shopify:section:reorder', scheduleApply);
})();
